import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EfImg from '@elem/ui/ef-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EFXFusion from 'elem/ui-assets/icons/unregular/EFXFusion';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionF');
    const { locale = 'us' } = useRouter();

    const bg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745743582799/SectionF%20pc.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1745743582799/SectionF%20pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745743582611/SectionF%20h5.jpg',
    }

    return (
        <div className={styles.comp} id="SectionF">
            <EcoSpace />
            <div className="section-container">
                <div className="content-wrapper">
                    <div className="title-area">
                        <EFXFusion className="logo" color="#000"/>
                    </div>
                    <div className="desc-area">
                        <p className="desc-text">{t('desc')}</p>
                        <p className="desc-tip">{t('tip')}</p>
                        <div className="link-flex-container">
                        <a href={`/${locale}/x-core-3`} className="learn-more">{t('learnMore')} {`${locale}`.toUpperCase()}</a>
                            <span className='learn-more-arrow'></span>
                        </div>
                        
                    </div>
                </div>
                <EcoSpaceSmall />
                <div className="video-wrapper">
                    <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
                </div>
            </div>
        </div>
    );
}